import React, { Fragment } from "react";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { notificationValidations } from "./notificationConstant";

const SMSNotification = ({
    handleMessageData,
    messageData
}) => {
    return (
        <Fragment>
            <label className="title" style={{ fontSize: "14px", fontWeight: "bold" }}>Message</label>
            <div className="content-block position-relative send-notification-message" style={{ marginTop: "10px" }}>
                <div className="py-15">
                    <div className="send-notification-field-row">
                        <label className="title" style={{ color: 'black', fontSize: '14px' }}>Message:</label>
                        <div style={{ flex: "0 1 auto", minWidth: 0 }}>
                            <TextareaAutosize
                                aria-label="minimum height"
                                placeholder="Write a Message"
                                style={{ height: '100px', padding: "10px", width: "100%", minWidth: 280, maxWidth: 500, boxSizing: "border-box" }}
                                onChange={(e) => {
                                    handleMessageData((e.target.value).substring(0, notificationValidations?.sms?.body?.maxLength))
                                }}
                                value={messageData}
                            />
                            <p>{(messageData?.length > notificationValidations?.sms?.body?.maxLength ? notificationValidations?.sms?.body?.maxLength : messageData?.length) + "/" + notificationValidations?.sms?.body?.maxLength}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


export default SMSNotification